// Gemeinsamer Rahmen für Mieter- und Eigentümerportal: Logo, Tabs aus der URL, rechts optionale
// Aktion und Profilmenü. Der Tab steht in der Adresse (/mieterportal/meldungen) – Zurück im
// Browser und Lesezeichen funktionieren.
import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import type { Icon } from '@phosphor-icons/react';
import { PortalMarke, PortalProfilMenue, PortalShell, PortalTabs } from './PortalShell';
import { gueltigerTab, type TabInfo } from '../../lib/portal/tabs';

export function usePortalTab<K extends string>(tabs: TabInfo<K>[], basis: string): [K, (k: K) => void] {
  const { tab } = useParams();
  const navigate = useNavigate();
  const aktiv = gueltigerTab(tabs, tab);
  return [aktiv, (k: K) => { navigate(k === tabs[0].key ? basis : `${basis}/${k}`); window.scrollTo(0, 0); }];
}

export default function PortalRahmen<K extends string>({ portal, tabs, ohneTabs = false, symbole, aktiv, onTab, anzahl, aktion, profil, profilTip, children }: {
  portal: 'Mieterportal' | 'Eigentümerportal';
  tabs: TabInfo<K>[];
  /** Kopfzeile ohne Bereiche (z. B. Vorauswahl der Objekte, #584) */
  ohneTabs?: boolean;
  symbole: Record<K, Icon>;
  aktiv: K;
  onTab: (k: K) => void;
  anzahl?: Partial<Record<K, number>>;
  aktion?: React.ReactNode;
  profil: { name: string; email: string };
  profilTip: string;
  children: React.ReactNode;
}) {
  return (
    <PortalShell
      breite="portal"
      tabsZeile={!ohneTabs}
      links={<PortalMarke portal={portal} />}
      mitte={ohneTabs ? undefined : (
        <PortalTabs
          label="Bereiche"
          aktiv={aktiv}
          onWahl={onTab}
          tabs={tabs.map((t) => ({ key: t.key, label: t.label, tip: t.tip, icon: symbole[t.key], anzahl: anzahl?.[t.key] }))}
        />
      )}
      rechts={(
        <>
          {aktion}
          <PortalProfilMenue name={profil.name} email={profil.email} tip={profilTip} abmeldenTip={`Vom ${portal} abmelden`} />
        </>
      )}
    >
      {children}
    </PortalShell>
  );
}
